(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-case-exclusions', {
            parent: 'app',
            url: '/download-case-exclusions',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.caseExclusions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-case-exclusions/download-case-exclusions.html',
                    controller: 'DownloadCaseExclusionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('case-exclusions');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('/download-case-exclusions.requested', {
            parent: 'download-case-exclusions',
            url: '/requested/{id}?user',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.caseExclusions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-case-exclusions/request-case-exclusions.html',
                    controller: 'RequestCaseExclusionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadActivityReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });

    }

})();
